export default "__VITE_ASSET__Ct7r7i0S__"